/* @flow */
import * as React from 'react';

import AuthActions from 'auth/AuthActions';
import BoxBody from 'components/BoxBody';
import BoxFooter from 'components/BoxFooter';
import Button from 'components/Button';
import DialogContent from 'components/DialogContent';
import EventTracking from 'lib/EventTracking';
import FormDeprecated from 'components/FormDeprecated';
import FormInput from 'components/FormInput';
import Link from 'components/Link';
import Row from 'components/Row';
import ToastActions from 'actions/ToastActions';
import TosText from 'components/TosText';
import UserActions from 'user/UserActions';
import User from 'entities/User';
import errorLogger from 'utils/errorLogger';

type Props = {
  onDone: User => void,
  onError: any => void,
};

type State = {
  canSubmit: boolean,
};

class JoinInfoPageCreateFullAccount extends React.Component<Props, State> {
  state = {
    canSubmit: false,
  };

  onPreexistingAccount = () => {
    AuthActions.signOut('/log_in');
  };

  onSubmit = (attrs: { email: string, password: string }, _: any, invalidateForm: Function) => {
    const onSuccess = user => {
      AuthActions.signIn(attrs.email, attrs.password)
        .then(() => {
          this.props.onDone(user);
        })
        .catch(errorLogger('JoinInfoPageCreateFullAccount onSubmit failed'));

      EventTracking.trackKey('tos_and_pp.view');
    };

    const onFailure = error => {
      if (!error || error.code !== 'validation_error') {
        ToastActions.showDefaultErrorToast();
        return;
      }

      this.props.onError(error);

      const errors = {};
      for (const field of error.field_errors) {
        errors[field['field_name']] = field.messages.join(', ');
      }

      invalidateForm(errors);
    };

    UserActions.update({ email: attrs.email, password: attrs.password }).then(onSuccess, onFailure);
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  render() {
    return (
      <DialogContent
        size="small"
        full
        className="JoinInfoPageCreateFullAccount"
        title={'Enter account details'}>
        <BoxBody divided>
          <FormDeprecated
            onValid={this.enableButton}
            onInvalid={this.disableButton}
            onValidSubmit={this.onSubmit}>
            <FormInput
              label="Email address"
              type="email"
              name="email"
              // even though this is an email, let the browser know to use this as username in the future
              autoComplete="username"
              placeholder="Email address"
              validations="isEmail"
              showErrorAfterBlur
              className="JoinInfoPageCreateFullAccount-Email"
              validationError="Invalid email address. Please try again."
            />
            <FormInput
              label="Choose a password"
              name="password"
              placeholder="Password"
              type="password"
              autoComplete="new-password"
              validOnPristine
              validations="minLength:6"
              className="JoinInfoPageCreateFullAccount-Password"
              validationError="Passwords should be at least 6 characters long."
            />
            <Button
              className="JoinInfoPageCreateFullAccount-Submit"
              disabled={!this.state.canSubmit}
              type="submit"
              eventElementName="JoinInfoPageCreateFullAccount-Submit">
              Done
            </Button>
          </FormDeprecated>
        </BoxBody>
        <BoxFooter className="JoinInfoPageCreateFullAccount-footer">
          <Row size="small">
            <TosText />
          </Row>
          Already have an account? <Link onClick={this.onPreexistingAccount}>Log in</Link>.
        </BoxFooter>
      </DialogContent>
    );
  }
}

export default JoinInfoPageCreateFullAccount;
